import { StateUtils } from 'utils';

const ARTISTS = 'ArtistsManagement';
const tag = StateUtils.actionType(ARTISTS);

export const BEFORE_PROCESSING = tag`BEFORE_FETCH_ARTISTS`;
export const ROLLBACK_INITIAL_STATE = tag`INITIAL_STATE`;
export const ON_FETCH_ARTISTS = tag`ON_FETCH_ARTISTS`;
export const ON_UPDATE_ARTIST = tag`ON_UPDATE_ARTIST`;
